<template lang="html">
  <v-page :profile="profile">
    <v-topbar :profile="profile" />
    <v-breadcrumb
      :steps="[
        { label: 'Profissionais', to: { name: 'client-vibbrants' } },
        { label: 'Perfil' },
      ]"
    />
    <v-container>
      <v-vibbrant-profile :user="vibbrante" />
    </v-container>
  </v-page>
</template>

<script>
import VibbrantProfile from '@/parts/modules/vibbrant-profile-full';
import clientApi from '@/api/client';

export default {
  components: {
    'v-vibbrant-profile': VibbrantProfile,
  },
  props: {
    vibbrante: Object,
    profile: {
      default: 'client',
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    click() {
      this.$emit('click');
    },
    fetchData() {
      clientApi
        .clientLoadVibbrante(this.$route.params.id)
        .then(response => {
          this.vibbrante = response.data;
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
      clientApi
        .clientBalances()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientBalance', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });

      clientApi
        .clientNotifications()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadClientNotifications', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
  },
  computed: {
    theClass() {
      return 'type-' + config.profile.names[this.user.type];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/pages/client/vibbrante-profile-page.vue